import {Icon} from '@blueprintjs/core'

import {XRefSidebarFieldStore, useFieldRendererStore} from '@design-board/stores'
import {Add, ArrowDropDown} from '@material-ui/icons'
import {CatalogItemsListChip, NoImagePlaceholder, SidebarAlign} from '@modules'
import {CatalogItemsChooser} from '@lazy'
import {DetailsViewFieldConfig, useCatalog} from '@stores'
import {React, observer, classNames, useLocalStore, _, Fragment} from '@api'
import {DataMapper, PrimaryIconButton, SecondaryButton, LazyImage} from 'centric-ui-components'
import {action, computed, observable} from 'mobx'
import * as css from './XRefSidebarField.css'
import {Collapse, Tooltip} from '@material-ui/core'
import {C8AttributesSelectFieldRenderer} from './'
import {LinkOff} from '@material-ui/icons'
import { Tooltip2 } from '@api'

export const XRefSidebarField = observer<{ align: SidebarAlign, className?: string, field: DetailsViewFieldConfig }>(function XRefSidebarField({align, className, field: {hasSeparator}}) {
  const store = useFieldRendererStore(),
    {strings, value: {val}, selectedValues, label, catalogField, field, detailsStore: {anchorEl}, fieldRenderer, editable, def, type} = store,
    {togglePopover, showPopover, onSelectCatalogItem, dataMap, onDelete} = useLocalStore(() => new XRefSidebarFieldStore(store))
  const isEditableField = editable && (align == 'right' || align == 'modal' || align == 'inline'),
    isEnum = type == 'Enum' || type == 'EnumList' || type  == 'LookupItem' || type == 'LookupItemList'

  // console.log({field, def, type, fieldRenderer, isEnum, isEditableField})

  return <div className={classNames(css.root, className)}>
    {
      // TODO- need a way to handle it better way
      !isEnum && val === null && fieldRenderer != 'dropdown' ?
      (isEditableField
       ? <SecondaryButton onClick={togglePopover} className={css.notAssignedAddButton}>Add {def?.displayName?.plural ?? label}</SecondaryButton>
       : <div>No {label} is assigned.</div>)
                                                             : fieldRenderer == 'chip'
                                                               ? <div className={css.chips}>
                                                                 {val && _.isArray(val) && val.map((d, i) => <DataMapper key={i} config={dataMap} data={d} nullValue={strings.emptyLabel}>
                                                                   <CatalogItemsListChip onDelete={isEditableField ? onDelete : undefined}/>
                                                                 </DataMapper>)}
                                                                 {isEditableField && <PrimaryIconButton icon={<Add/>} className={css.addButton} onClick={togglePopover}/>}
                                                               </div>
                                                               : fieldRenderer == 'text'
                                                                 ? <div className={css.textXref} onClick={togglePopover}>{val}<ArrowDropDown className={css.xrefDropdown} fontSize={'small'}/></div>
                                                                 : fieldRenderer == 'cardGroup'
                                                                   ? <Fragment>
                                                                     <XRefCards withSeparator={hasSeparator} className={css.xrefField}/>
                                                                     {isEditableField ? <SecondaryButton onClick={togglePopover} className={css.notAssignedAddButton}>Add {def?.displayName?.plural ?? label}</SecondaryButton> : null}
                                                                   </Fragment>
                                                                   : <C8AttributesSelectFieldRenderer c8Enum={def?.enumType} subtype={def?.subType}/>
    }

    <CatalogItemsChooser anchorEl={anchorEl}
                         onClose={togglePopover}
                         open={showPopover}
                         field={field}
                         selectedValues={selectedValues}
                         onSelectCatalogItem={onSelectCatalogItem}
                         onDeleteCatalogItem={onDelete}
    />
  </div>
})

// separate file
// useAsync

const XRefCards = observer<{ withSeparator?: Boolean, className?: string }>(function XRefCards({withSeparator, className}) {
  const store = useFieldRendererStore(),
    {strings, catalog: {imageUrlFor}, value: {val}, label, field: {nested}, dataMap} = store

  if (_.isEmpty(val)) {return <div>No {label} is assigned.</div>}
  switch (withSeparator) {
    case true:
      const imageURL = val?.images?.length ? imageUrlFor(val.images[0], {c8Size: 'thumbnailImage'}) : null
      const primaryCard = <DataMapper config={dataMap} data={val}>
        <XRefCard imageURL={imageURL} className={className} target='root'/>
      </DataMapper>
      return (<div className={css.primaryCard}>
        {primaryCard}
        {nested && <NestedXRefCards/>}
      </div>)
    default:
      return <Fragment>
        {val?.map((cardData, i) => {
          const imageURL = cardData?.images?.length ? imageUrlFor(cardData.images[0], {c8Size: 'thumbnailImage'}) : null
          return <DataMapper key={i} config={dataMap} data={cardData} nullValue={strings.emptyLabel}>
            <XRefCard imageURL={imageURL}
                      className={className}
                      target='root'
            />
          </DataMapper>
        })}
      </Fragment>
  }
})

export const NestedXRefCards = observer<{nestedListItem?: any, collapsible?: boolean}>(function NestedXRefCards ({nestedListItem = {}, collapsible=true}) {
  const store = useFieldRendererStore(),
    {strings, catalog: {imageUrlFor}, value: {val}, field: {nested}, nestedLabel, nestedValue, showNested, nestedDataMap: dataMap, toggleShowNested} = store,
    genericNestedValue = !_.isEmpty(nestedListItem) ? _.get(nestedListItem, nested?.field) : nestedValue

  return (
    <div className={css.nestedCards}>
      {!val ? <div>No {nested.field} value</div>
            : <Fragment>
         {collapsible ? <div className={css.separator}>{nestedLabel} ({genericNestedValue?.length || 0}) <span className={css.clickable} onClick={e => toggleShowNested(nestedListItem?.id)}>{showNested.get(nestedListItem?.id) ? 'Hide' : 'Show'} {nestedLabel}</span></div> : null}

         <Collapse in={showNested.get(nestedListItem?.id) || !collapsible} timeout="auto" unmountOnExit>
           <div className={css.nestedCards}>
             {
               _.isArray(genericNestedValue) && genericNestedValue.map((cardData, i) => {
                 const imageURL = cardData?.images?.length ? imageUrlFor(cardData.images[0], {c8Size: 'thumbnailImage'}) : null
                 return <DataMapper key={i} config={dataMap} data={cardData} nullValue={strings.emptyLabel}>
                   <XRefCard key={i}
                             target='nested'
                             imageURL={imageURL}
                             className={css.nestedCard}/>
                 </DataMapper>
               })
             }
           </div>
         </Collapse>
       </Fragment>}
    </div>)
})

interface XRefCardProps {
  className?: string
  imageURL?: string
  target: 'root' | 'nested'
  placeholderText?: string
  data?: {
    id?
    exId?
    title?: string
    subtitle1?: string
  } & any
}

const XRefCard = observer<XRefCardProps>(function XRefCard({className, imageURL, target, data, data: {title, subtitle1}}) {
  const {strings, toggleNestedLibraryDetails, onImageLoadError, imageLoadError, detailsStore: {sidebar: {open, align, whereEqual, selectedPathItem}}, field: {nested}, library} = useFieldRendererStore(),
    catalog = useCatalog(),
    id = data.exId ?? data.id ?? data._id,
    showingDetails = id && open && whereEqual(data, selectedPathItem?.where) == id,
    active = data?.attributes?.Active === true
  // TODO - shouldn't we use ListPreviewCard?
const activeFieldDef = library && library?.showStatusLabel && catalog.getLibraryFieldDef(library?.dataMap?.active, library?.index)
  return (
    <div className={classNames(css.cardRoot, className)}>
      <div className={classNames({[css.diagonal]: !active})}/>
      <div className={css.imageWrapper}>
        <div className={css.cardImage}>
          {
            imageLoadError ? <div className={css.offLink}><LinkOff className={css.image}/></div> : imageURL ? <LazyImage onError={onImageLoadError} className={css.image} src={imageURL}/> : <NoImagePlaceholder placeholderImg={null} placeholderText={'No Image'}/>
          }
        </div>
      </div>
      <div className={css.cardContent}>
        <p>{title}</p>
        {subtitle1 && <p>{subtitle1}</p>}
        {activeFieldDef?.def && <div className={css.status} style={{ color: active ? 'var(--green)' : 'var(--red)' }}>{active ? activeFieldDef?.def?.tileBooleanLabels?.trueLabel : activeFieldDef?.def?.tileBooleanLabels?.falseLabel}</div>}
      </div>

      {id && !nested?.hideActions &&
	   <div className={css.buttons}>

			   <PrimaryIconButton
             tooltip={strings.drillDown}
				   onClick={() => toggleNestedLibraryDetails(id, align, target)}>
				   <Icon icon='arrow-right' iconSize={16}/>
			   </PrimaryIconButton>

         {align == 'right' &&
			 <PrimaryIconButton
           tooltip={!showingDetails ? `${strings.show} '${title}' ${strings.details}` : `${strings.hide} '${title}' ${strings.details}`}
				 active={showingDetails}
				 onClick={() => toggleNestedLibraryDetails(id, 'left', target)}>
				 <Icon icon='list-detail-view' iconSize={16}/>
			 </PrimaryIconButton>}
	   </div>}
    </div>)
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/XRefSidebarField.tsx